/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const markedEmailsCountDataSchema = z.object({
	markedCount: z.number(),
})

export type MarkedEmailsCountDataSchema = z.infer<typeof markedEmailsCountDataSchema>
